import React from "react";

import { localizer } from "../../../Translator";

import { Grid } from "@material-ui/core";
import { TableContainer, TableHead, TableBody, TableCell } from "@material-ui/core";
import { Paper } from "@material-ui/core";

import { TableRowHeaderStyled} from '../../common/TableStyled.js'
import { TableStyled } from '../../common/TableStyled.js'

import { EmailAddress } from "./EmailAddress"

import AuthCli from '../../../sdk/AuthCli'

export class EmailAddressList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Initial email address list to be filled by parent component EmailAddressLayout
      emails: [],
      
      // Currently email logged in user.
       currentSessionEmail: null,
    }
  }

  /* Initialization of email address list. Email address list is given by parent props */
  componentDidMount() {
    this.setState({ emails: this.props.emails })
    // Get email user.
    AuthCli.GetSessionInfo().then(session => {
      if (session) {
        this.setState({ currentSessionEmail: session.userEmail.toLowerCase() })
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.emails === this.props.emails) return
    this.setState({ emails: this.props.emails })  

  }

  render() {
    return (
      <React.Fragment>

        <Grid container direction="row" justify="center" alignItems="center" spacing={4} className="pt-25">
          <TableContainer component={Paper}>
            <TableStyled>
              <TableHead>
                <TableRowHeaderStyled>
                  <TableCell align="center"></TableCell>
                  <TableCell className="typography-generic tablerow-header" align="center">{localizer.EmailAddressEmail}</TableCell>
                  <TableCell className="typography-generic tablerow-header" align="center">{localizer.EmailAddressValidateEmail}</TableCell>
                  <TableCell className="typography-generic tablerow-header" align="center">{localizer.EmailAddressCertificateEmail}</TableCell>
                  <TableCell className="typography-generic tablerow-header" align="center">{localizer.EmailAddressEmissionEmail}</TableCell>
                  <TableCell className="typography-generic tablerow-header" align="center">{localizer.EmailAddressRemove}</TableCell>
                </TableRowHeaderStyled>
              </TableHead>
              <TableBody>
                {this.state.currentSessionEmail !== null &&
                  <EmailAddress key={this.state.currentSessionEmail} email={this.state.currentSessionEmail} certificateEmail={this.props.certificateEmail} emissionEmail={this.props.emissionEmail } handleEmail={this.props.handleEmail}></EmailAddress>
                }             
                <tr><td colSpan={6}><hr className="hr-currentemail"/></td></tr>
                {this.state.emails.map(email => {
                  return (
                    <EmailAddress key={email} email={email} certificateEmail={this.props.certificateEmail} emissionEmail={this.props.emissionEmail } handleEmail={this.props.handleEmail}></EmailAddress>
                  )
                })}
              </TableBody>
            </TableStyled>
          </TableContainer>
        </Grid>

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/email-address/sections/EmailAddressList.js